// LA LECCIÓN EN EL MÓVIL ES SOLO EL CHAT, como quien entra en WhatsApp (Gabri, 3 de noviembre de
// 2026): sin barra ni pie, que distraen. Cada pieza del armazón se esconde sola con esta clase,
// y se sale por la flecha de la cabecera del mentor. En el ordenador siguen en su sitio.
const LECCION = /^\/cursos\/[^/]+\/leccion\//;

export const esLeccion = (ruta) => LECCION.test(String(ruta || ""));
export const fueraDeLaLeccion = (ruta) => (esLeccion(ruta) ? "max-md:hidden" : "");
